<div class="container-fluid bg-grey">
    <swiper-container init="false" class="swiper-container-logo-slider my-3">
        <swiper-slide *ngFor="let logo of customerLogos">
            <div class="d-flex justify-content-center align-items-center" style="height: 100%">
                <img [src]="logo.src" alt="{{ logo.alt }}" />
            </div>
        </swiper-slide>
    </swiper-container>
</div>
